import React from "react";

// Components
import {
  DashboardInner,
  DashboardWrapper,
} from "../components/DashboardWrapper/DashboardWrapper.styles";
import PatientList from "../components/PatientList";
import { Card, Typography } from "antd";
import { use } from "react";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const PatientListPage = () => {
  const navigate = useNavigate();

  return (
    <DashboardWrapper>
      
      <PatientList/>
    </DashboardWrapper>
  );
};

export default PatientListPage;
